// INFO:
// in the backend each washing programs is associated with a vehicles sizes (city, sedan, suv_4x4, compact...)
// but for twip web the field segment on each vehicles use small/medium/large
// we need to map the washing program vehicles size to the segment of twip web
const vehicleTypeMapping = {
  sedan: 'medium',
  suv_4x4: 'large',
  compact: 'small'
}

const state = {
  station: {}
}

const getters = {
  getStation: state => state.station.fields,
  getAddons: state => {
    if (state.station.fields && state.station.fields.washingprogramspecific_set) {
      return state.station.fields.washingprogramspecific_set
        .filter(washingProgram => {
          return !!(washingProgram.fields
            && washingProgram.fields.product_sku
            && washingProgram.fields.product_sku.match(/^Autowash\/Twip\/Addon\//g))
        })
        // filter out addons that have no deals or price is 0
        .filter(washingProgram => {
          return !!(washingProgram.fields.best_deals.length > 0
            && washingProgram.fields.best_deals[0].fields
            && Number(washingProgram.fields.best_deals[0].fields.price_after_discount) > 0)
        })
        .reduce((acc, washingProgram) => {
          const deals = washingProgram.fields.best_deals.reduce((acc2, deal) => {
            for (const vehicleType of deal.fields.vehicle_sizes) {
              // filter offer of vehicle not compatible
              if (vehicleTypeMapping[vehicleType] === undefined) continue
              acc2.push({
                offerId: deal.pk,
                name: washingProgram.fields.name,
                priceIncludingTaxes: Number(deal.fields.price_after_discount),
                priceExcludingTaxes: Number(deal.fields.price_after_discount_excl_tax),
                vehicleType: vehicleTypeMapping[vehicleType],
                description: washingProgram.fields.description
              })
            }
            return acc2
          }, [])
          deals.forEach(deal => acc.push(deal))
          return acc
        }, [])
    }
    return []
  },
  getOffers: state => {
    if (state.station.fields && state.station.fields.washingprogramspecific_set) {
      return state.station.fields.washingprogramspecific_set
        .filter(washingProgram => {
          return !!(washingProgram.fields
            && washingProgram.fields.product_sku
            && !washingProgram.fields.product_sku.match(/^Autowash\/Twip\/Addon\//g))
        })
        .reduce((acc, washingProgram) => {
          const deals = washingProgram.fields.best_deals.reduce((acc2, deal) => {
            for (const vehicleType of deal.fields.vehicle_sizes) {
              // filter offer of vehicle not compatible
              if (vehicleTypeMapping[vehicleType] === undefined) continue
              acc2.push({
                offerId: deal.pk,
                name: washingProgram.fields.name,
                priceIncludingTaxes: Number(deal.fields.price_after_discount),
                priceExcludingTaxes: Number(deal.fields.price_after_discount_excl_tax),
                vehicleType: vehicleTypeMapping[vehicleType],
                description: washingProgram.fields.description
              })
            }
            return acc2
          }, [])
          deals.forEach(deal => acc.push(deal))
          return acc
        }, [])
    }
    return []
  },
  getOffersForVehiclesTypes: (state, getters) => (vehicleTypes =>
    getters.getOffers.filter(
      offer => vehicleTypes.indexOf(offer.vehicleType) >= 0
    )
  ),
  getAddonsForVehiclesTypes: (state, getters) => (vehicleTypes =>
    getters.getAddons.filter(
      offer => vehicleTypes.indexOf(offer.vehicleType) >= 0
    )
  ),
  getOpeningHours: state => {
    if (state.station.fields && state.station.fields.openinghoursstation_set) {
      return state.station.fields.openinghoursstation_set.map(oh => ({
        day: oh.fields.day,
        opens: oh.fields.start_hour,
        closes: oh.fields.end_hour
      }))
    }
    return []
  },
  getStationId: state => state.station.pk,
  // wash duration is the same for all washing programs in the station
  getWashDuration: state => {
    if (state.station.fields && state.station.fields.washingprogramspecific_set) {
      return state.station.fields.washingprogramspecific_set[0].fields.duration
    }
    return null
  }
}

const mutations = {
  setStation(state, payload) {
    state.station = payload
  },
}
const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}